export default {
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ""
    },
    showClose: {
      type: Boolean,
      default: true
    },
    showFullscreen: {
      type: Boolean,
      default: true
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dialogVisible: false,
      isFullscreen: false
    };
  },
  watch: {
    modelValue() {
      this.dialogVisible = this.modelValue;
      if (this.dialogVisible) {
        this.isFullscreen = false;
      }
    }
  },
  mounted() {
    this.dialogVisible = this.modelValue;
  },
  methods: {
    //关闭
    closeDialog() {
      this.dialogVisible = false;
    },
    //最大化
    setFullscreen() {
      this.isFullscreen = !this.isFullscreen;
    }
  }
};